import { OperatorsEnum } from "./enums/OperatorsEnum";

type ValuesType = {
    name: string;
    value: string;
    operator: OperatorsEnum;
}

export default class SearchFilter {
    private readonly urlSerachParams: URLSearchParams;
    private values: ValuesType[] = [];

    constructor() {
        this.urlSerachParams = new URLSearchParams();
    }

    public addFilter(name: string, value: any, operator: OperatorsEnum): void {
        this.values.push({ name, value, operator });
    }

    public getFilters(): ValuesType[] {
        return this.values;
    }

    /**
     * 
     * @param startDate YYYY-MM-DD
     * @param endDate YYYY-MM-DD
     */
    public addRangeDate(startDate: string, endDate: string): void {
        this.urlSerachParams.set('range_date[start_date]', startDate);
        this.urlSerachParams.set('range_date[end_date]', endDate);
    }

    public addFilterList(list: { name: string, value: any }[]): void {
        list.forEach(({ name, value }) => {
            this.urlSerachParams.append(`filter_by[]`, name);
            this.urlSerachParams.append(`filter_value[]`, value);
        });
    }

    public addPagination(page: number, perPage: number) {
        this.urlSerachParams.set(`pagination[page]`, String(page));
        this.urlSerachParams.set(`pagination[per_page]`, String(perPage));
    }

    public getQuery(): string {
        this.values.forEach(({ name, operator, value }, i) => {
            this.urlSerachParams.append(`filter[eq][${name}]`, value);
        });

        return this.urlSerachParams.toString();
    }
}